<script setup lang="ts">
import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { APP_VERSION } from '@Constants';
import { useChunkPreloadErrorHandling } from '@Composables';
import { useSessionStore } from '@Stores';
import { useAToast } from '@Atoms';

const { isLogged } = storeToRefs(useSessionStore());
const { state, isOnHover } = useAToast();
const ROUTE = useRoute();
const ROUTER = useRouter();

useChunkPreloadErrorHandling();

watch(isLogged, () => checkUserSession());

function checkUserSession() {
  if (isLogged.value) return;
  if (ROUTE.path === '/login') return;

  const momentForLocalStorageAcrossTabsToSync = 10;
  setTimeout(() => {
    ROUTER.push('/login');
  }, momentForLocalStorageAcrossTabsToSync);
}

console.log('App version', APP_VERSION);
</script>

<template>
  <RouterView />

  <AToast
    v-bind="state"
    @mouseenter="isOnHover = true"
    @mouseleave="isOnHover = false"
    @onDismiss="state.isOpen = false"
  />
</template>
